import React, { useEffect } from 'react';
import "./CustomCalendar.scss"
import { useTranslation } from "react-i18next";
import { getNumberOfDays } from '../../helpers/dateHelpers';

function CustomCalendar({ blockDates, selectedFilters }) {
    const { t } = useTranslation();

    const loadSelectedCalendarDates = () => {
        const dateItems = document.querySelectorAll(".calendar-container .day");
        if (dateItems && dateItems.length > 0) {
            let selectedTimes = selectedFilters.selectedDateFilter.dates.map(date => date.getTime());
            dateItems.forEach(dateElement => {
                const selectedDateElement = dateElement as Element;
                let selectedDateTime = new Date(selectedDateElement.getAttribute("data-value") + " 00:00").getTime();
                if (selectedTimes.length > 0 && selectedTimes.includes(selectedDateTime)) {
                    if (!selectedDateElement.classList.contains("selected-calendar-date")) {
                        selectedDateElement.classList?.add("selected-calendar-date");
                    }
                }
            });
        }
    }

    useEffect(() => {
        if (!blockDates) {
            return;
        }
        const arrDateCalender = getNumberOfDays(blockDates.start, blockDates.end);
        const calendarContainer = document.querySelector(".calendar-container");
        if (calendarContainer) {
            arrDateCalender.forEach((day) => {
                const currDate = new Date(day+" 00:00");
                const date = currDate.getDate();
                if (day === arrDateCalender[0]) {
                    for (let weekCount = 0; weekCount < 6; weekCount++) {
                        if (currDate.getDay() !== weekCount) {
                            calendarContainer.insertAdjacentHTML(
                                "beforeend",
                                `<div></div>`
                            );
                        }
                        else {
                            break;
                        }
                    }
                }
                calendarContainer.insertAdjacentHTML(
                    "beforeend",
                    `<div class="day" data-value=${day}>${date}</div>`
                );
            });

            document.querySelectorAll(".calendar-container .day").forEach((day) => {
                day.addEventListener("click", (event) => {
                    const selectedDate = event.target as Element;
                    selectedDate?.classList?.toggle("selected-calendar-date");
                });
            });

            loadSelectedCalendarDates();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [blockDates]);

    return (
        <div className="calendar-container">
            <div className="week-header">{t('filters.dateTime.sun')}</div>
            <div className="week-header">{t('filters.dateTime.mon')}</div>
            <div className="week-header">{t('filters.dateTime.tue')}</div>
            <div className="week-header">{t('filters.dateTime.wed')}</div>
            <div className="week-header">{t('filters.dateTime.thu')}</div>
            <div className="week-header">{t('filters.dateTime.fri')}</div>
            <div className="week-header">{t('filters.dateTime.sat')}</div>
        </div>
    );
}

export default CustomCalendar;
